/**
 *
 * @param {Date} date объект даты
 * @param {Intl.DateTimeFormatOptions} options формат
 * @returns {string} форматированная строка
 * @example '22:20'
 */
export default function getFormattedTime(
  date,
  options = {
    hour: '2-digit',
    minute: '2-digit',
  }
) {
  return date.toLocaleString('ru-Ru', options)
}
